module.exports = __webpack_public_path__ + "img/service.3f65347b.jpg";